/**
 * @name ClientAppointmentsModalController
 * @description Function to update clients who are still new users
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} client Resolved client from the client list controller
 * @param {unknown} appointments Resolved appointments from the client list controller
 */
function ClientAppointmentsModalController(
$uibModalInstance,
client,
appointments) {
  let vm = this;
  vm.client = client;
  vm.appointments = appointments;

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
  .module('inkfinder')
  .controller('ClientAppointmentsModalController', ClientAppointmentsModalController);



// WEBPACK FOOTER //
// ./components/clients-list/appointments/client-appointments-modal.controller.js